module.exports = __webpack_public_path__ + "img/01.3d410ee6.jpg";